import React from 'react';
import { useTranslation } from 'react-i18next';
import PersonnelPaymentManagement from './PersonnelPaymentManagement';

const PersonnelPayments = () => {
  const { t } = useTranslation();

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6">
      <PersonnelPaymentManagement />
    </div>
  );
};

export default PersonnelPayments;